import {useAiFillFlash, useFieldAiProps} from '@/features/ai-extraction';
import {AssetAttachmentsFields} from '@/features/buyers/components';

import type {AiSuggestion} from '@/features/ai-extraction';
import type {CreateBuyerFormValues} from '@/features/buyers/validation';
import type {FC} from 'react';
import type {UseFormReturn} from 'react-hook-form';

export interface UnitAttachmentsSectionProps {
  form: UseFormReturn<CreateBuyerFormValues>;
  aiFields: Map<string, AiSuggestion>;
  isProcessing: boolean;
  markFieldModified: (field: string) => void;
}

export const UnitAttachmentsSection: FC<UnitAttachmentsSectionProps> = ({
  form,
  aiFields,
  isProcessing,
  markFieldModified
}) => {
  const {
    register,
    control,
    formState: {errors}
  } = form;

  const fieldAi = useFieldAiProps({
    aiFields,
    isProcessing,
    markFieldModified,
    getValue: form.getValues
  });
  const isFlashing = useAiFillFlash(aiFields);

  return (
    <AssetAttachmentsFields
      control={control}
      register={register}
      errors={errors}
      namePrefix="asset.attachments"
      typeLabelRequired
      ai={{fieldAi, isFlashing, aiFields, getValues: form.getValues}}
    />
  );
};
